const LogoIcon = () => {
   return <img src="/logo-icon.svg" alt={"logo"} className="max-h-8 animate-pulse" />
}

export default LogoIcon
